import { Base, createApp } from '@studiometa/js-toolkit';
import { ArchivesGallery } from './components/ArchivesGallery/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      ArchivesGallery,
    },
  };
}

export default createApp(App, document.documentElement);
